// @flow
import React, { Component } from 'react'
import SelectControl from '../../controls/Select'
import { translations, translateFunc } from '../../../shared/localize'
import _ from 'lodash'
import type { Conversion as ConversionType } from '../../types'

const t = translateFunc(translations.audience_edit.conversion)

type Props = {|
  conversions: Array<ConversionType>,
  isDisabled: boolean,
  conversionId: ?number,
  onConversionIdChange: (number) => void
|}

export default class Select extends Component<Props> {
  render() {
    const { conversionId, isDisabled } = this.props
    const { conversions } = this.props

    return (
      <SelectControl
        value={conversionId}
        options={_.map(conversions, (conversion) => ({
          id: conversion.id,
          name: `${conversion.name} - ${conversion.domainName}`
        }))}
        onChange={(conversionId) => this.props.onConversionIdChange(conversionId)}
        placeholder={t('conversion_id_placeholder')}
        noResultsText={t('no_results')}
        disabled={isDisabled}
      />
    )
  }
}
